export const BODY_NAME: Record<string, string> = {
  '1': 'ライトボディ',
  '2': 'ミディアムボディ-',
  '3': 'ミディアムボディ',
  '4': 'ミディアムボディ+',
  '5': 'フルボディ',
};
